import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import WebsiteNavbar from "./website-navbar";
import WebsiteFooter from './website-footer';
import '../../tailwind.css';

export default function WebsiteLayout() {
    const [mobileOpen, setMobileOpen] = useState(false);
    
    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };
    
    return (
        <>
            <header>
                <Box sx={{ display: 'flex' }}>
                    <WebsiteNavbar handleDrawerToggle={handleDrawerToggle} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
                </Box>
            </header>
            <main>
                <Outlet/>
            </main>
            <footer>
                <WebsiteFooter />
            </footer>
        </>
    );
}